import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconStarGuide = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    viewBox="0 0 22 22"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#fff"
      fillOpacity={0.95}
      d="m12.094 1.703 2.578 5.195 5.703.82c1.016.157 1.445 1.407.703 2.15l-4.14 3.984.976 5.664c.156 1.015-.898 1.797-1.836 1.328L11 18.187l-5.117 2.696c-.938.469-1.992-.313-1.836-1.328l.976-5.664-4.14-4.024C.14 9.125.57 7.875 1.586 7.72l5.703-.82 2.578-5.196c.469-.937 1.797-.898 2.227 0Z"
    />
  </svg>
));
export default SvgIconStarGuide;
